import { IonButton, IonButtons, IonContent, IonHeader, IonImg, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Home.css';

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Welcome to CashOut - Simple Expense Manager</IonTitle>
          <IonButtons slot='end'>
            <IonButton color='success' routerLink='/Login'>Login</IonButton>
            <IonButton color='success' routerLink='/PrivacyPolicy'>Privacy Policy</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="headerImage">
          <div className='downloadBtns'>
            <a href="https://play.google.com/store/apps/details?id=uk.softwarestudio.expense" target='_blank'>
              <IonImg src="/assets/android-download.png" style={{height: 50}}></IonImg>
            </a>
            <a href="https://apps.apple.com/us/app/cash-out-simple-expense-track/id1483762315" target='_blank'>
              <IonImg src="/assets/appstorebtn.png" style={{height: 50}}></IonImg>
            </a>
          </div>
        </div>
        <div>
        <p>Start tracking your expenses and stay financially disciplined to save more with the simple expense tracker &amp; manager features of Cash Out!</p>

<p>Start tracking your expenses and stay financially disciplined to save more with the simple expense tracker &amp; manager features of Cash Out! We rethinked the expenditure tracker apps niche, which mostly consists of complicated apps that you will stop using after few uses, and introduce a simpler, and better way to track your expenses.</p>

<p>SIMPLE &amp; CONVENIENT TRACKING To help you manage your spending and expense trackings, we simplified the process and offered a neat UI. Data is save on google cloud to view it for later to compare it with the bank statements including credit card statements. Use the simple expense manager &amp; tracker to always add your transactions and spending fast.</p>

<p>VERY EASY TO USE Simply login through google account, select date by default current date will be selected for ease and enter amount spent and it will be saved. Using our expenditure recorder and simple expense sheet app, you can add daily, weekly or monthly expense at a glance.</p>

<p>NEAT PRESENTATION OF DATA All the record is shown in charts and detail of each month is shown in table to easily give user information about the money spent at selected day, month. Everything is so much clearer with our expense graphs and expenses pies.</p>

<p>If you want to start recording your expenses in a smarter way and stay on track with how your spend your money, there is rarely a better app than Cash Out.</p>
        </div>
        <IonImg src='/assets/screens.png' alt="Best easy expenditures tracker" style={{height:'400px'}}></IonImg>
      </IonContent>
    </IonPage>
  );
};

export default Home;
